// const telemedicinaLink = "http://localhost:8080/";
const telemedicinaLink = "https://cmh-tele-front-prod.azurewebsites.net/";
export default telemedicinaLink;